import { createContext as e, forwardRef as r, createElement as t } from "react";
import { Popover as n, Container as a, Arrow as o } from "@quid/react-popover";

function i() {
  return (i = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function s(e, r) {
  if (null == e) return {};
  var t,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r.indexOf(t = o[n]) >= 0 || (a[t] = e[t]);
  }

  return a;
}

var c = function c(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
};

function l(e) {
  var r = {};
  return function (t) {
    return void 0 === r[t] && (r[t] = e(t)), r[t];
  };
}

var u = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    d = l(function (e) {
  return u.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
}),
    p = function () {
  function e(e) {
    this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
  }

  var r = e.prototype;
  return r.insert = function (e) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var r = function (e) {
        var r = document.createElement("style");
        return r.setAttribute("data-emotion", e.key), void 0 !== e.nonce && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r;
      }(this);

      this.container.insertBefore(r, 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling), this.tags.push(r);
    }

    var t = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var n = function (e) {
        if (e.sheet) return e.sheet;

        for (var r = 0; r < document.styleSheets.length; r++) {
          if (document.styleSheets[r].ownerNode === e) return document.styleSheets[r];
        }
      }(t);

      try {
        var a = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
        n.insertRule(e, a ? 0 : n.cssRules.length);
      } catch (r) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', r);
      }
    } else t.appendChild(document.createTextNode(e));

    this.ctr++;
  }, r.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0;
  }, e;
}();

function f(e) {
  function r(e, r, n) {
    var a = r.trim().split(h);
    r = a;
    var o = a.length,
        i = e.length;

    switch (i) {
      case 0:
      case 1:
        var s = 0;

        for (e = 0 === i ? "" : e[0] + " "; s < o; ++s) {
          r[s] = t(e, r[s], n).trim();
        }

        break;

      default:
        var c = s = 0;

        for (r = []; s < o; ++s) {
          for (var l = 0; l < i; ++l) {
            r[c++] = t(e[l] + " ", a[s], n).trim();
          }
        }

    }

    return r;
  }

  function t(e, r, t) {
    var n = r.charCodeAt(0);

    switch (33 > n && (n = (r = r.trim()).charCodeAt(0)), n) {
      case 38:
        return r.replace(m, "$1" + e.trim());

      case 58:
        return e.trim() + r.replace(m, "$1" + e.trim());

      default:
        if (0 < 1 * t && 0 < r.indexOf("\f")) return r.replace(m, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }

    return e + r;
  }

  function n(e, r, t, o) {
    var i = e + ";",
        s = 2 * r + 3 * t + 4 * o;

    if (944 === s) {
      e = i.indexOf(":", 9) + 1;
      var c = i.substring(e, i.length - 1).trim();
      return c = i.substring(0, e).trim() + c + ";", 1 === I || 2 === I && a(c, 1) ? "-webkit-" + c + c : c;
    }

    if (0 === I || 2 === I && !a(i, 1)) return i;

    switch (s) {
      case 1015:
        return 97 === i.charCodeAt(10) ? "-webkit-" + i + i : i;

      case 951:
        return 116 === i.charCodeAt(3) ? "-webkit-" + i + i : i;

      case 963:
        return 110 === i.charCodeAt(5) ? "-webkit-" + i + i : i;

      case 1009:
        if (100 !== i.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + i + i;

      case 978:
        return "-webkit-" + i + "-moz-" + i + i;

      case 1019:
      case 983:
        return "-webkit-" + i + "-moz-" + i + "-ms-" + i + i;

      case 883:
        if (45 === i.charCodeAt(8)) return "-webkit-" + i + i;
        if (0 < i.indexOf("image-set(", 11)) return i.replace(E, "$1-webkit-$2") + i;
        break;

      case 932:
        if (45 === i.charCodeAt(4)) switch (i.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + i.replace("-grow", "") + "-webkit-" + i + "-ms-" + i.replace("grow", "positive") + i;

          case 115:
            return "-webkit-" + i + "-ms-" + i.replace("shrink", "negative") + i;

          case 98:
            return "-webkit-" + i + "-ms-" + i.replace("basis", "preferred-size") + i;
        }
        return "-webkit-" + i + "-ms-" + i + i;

      case 964:
        return "-webkit-" + i + "-ms-flex-" + i + i;

      case 1023:
        if (99 !== i.charCodeAt(8)) break;
        return "-webkit-box-pack" + (c = i.substring(i.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + i + "-ms-flex-pack" + c + i;

      case 1005:
        return p.test(i) ? i.replace(d, ":-webkit-") + i.replace(d, ":-moz-") + i : i;

      case 1e3:
        switch (r = (c = i.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(r)) {
          case 226:
            c = i.replace(y, "tb");
            break;

          case 232:
            c = i.replace(y, "tb-rl");
            break;

          case 220:
            c = i.replace(y, "lr");
            break;

          default:
            return i;
        }

        return "-webkit-" + i + "-ms-" + c + i;

      case 1017:
        if (-1 === i.indexOf("sticky", 9)) break;

      case 975:
        switch (r = (i = e).length - 10, s = (c = (33 === i.charCodeAt(r) ? i.substring(0, r) : i).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
          case 203:
            if (111 > c.charCodeAt(8)) break;

          case 115:
            i = i.replace(c, "-webkit-" + c) + ";" + i;
            break;

          case 207:
          case 102:
            i = i.replace(c, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + i.replace(c, "-webkit-" + c) + ";" + i.replace(c, "-ms-" + c + "box") + ";" + i;
        }

        return i + ";";

      case 938:
        if (45 === i.charCodeAt(5)) switch (i.charCodeAt(6)) {
          case 105:
            return c = i.replace("-items", ""), "-webkit-" + i + "-webkit-box-" + c + "-ms-flex-" + c + i;

          case 115:
            return "-webkit-" + i + "-ms-flex-item-" + i.replace(C, "") + i;

          default:
            return "-webkit-" + i + "-ms-flex-line-pack" + i.replace("align-content", "").replace(C, "") + i;
        }
        break;

      case 973:
      case 989:
        if (45 !== i.charCodeAt(3) || 122 === i.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === A.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? n(e.replace("stretch", "fill-available"), r, t, o).replace(":fill-available", ":stretch") : i.replace(c, "-webkit-" + c) + i.replace(c, "-moz-" + c.replace("fill-", "")) + i;
        break;

      case 962:
        if (i = "-webkit-" + i + (102 === i.charCodeAt(5) ? "-ms-" + i : "") + i, 211 === t + o && 105 === i.charCodeAt(13) && 0 < i.indexOf("transform", 10)) return i.substring(0, i.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + i;
    }

    return i;
  }

  function a(e, r) {
    var t = e.indexOf(1 === r ? ":" : "{"),
        n = e.substring(0, 3 !== r ? t : 10);
    return t = e.substring(t + 1, e.length - 1), V(2 !== r ? n : n.replace(x, "$1"), t, r);
  }

  function o(e, r) {
    var t = n(r, r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2));
    return t !== r + ";" ? t.replace(k, " or ($1)").substring(4) : "(" + r + ")";
  }

  function i(e, r, t, n, a, o, i, s, l, u) {
    for (var d, p = 0, f = r; p < G; ++p) {
      switch (d = B[p].call(c, e, f, t, n, a, o, i, s, l, u)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          f = d;
      }
    }

    if (f !== r) return f;
  }

  function s(e) {
    return void 0 !== (e = e.prefix) && (V = null, e ? "function" != typeof e ? I = 1 : (I = 2, V = e) : I = 0), s;
  }

  function c(e, t) {
    var s = e;

    if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < G) {
      var c = i(-1, t, s, s, _, O, 0, 0, 0, 0);
      void 0 !== c && "string" == typeof c && (t = c);
    }

    var d = function e(t, s, c, d, p) {
      for (var f, h, m, y, k, C = 0, x = 0, A = 0, E = 0, B = 0, V = 0, P = m = f = 0, R = 0, W = 0, T = 0, X = 0, j = c.length, D = j - 1, F = "", J = "", L = "", z = ""; R < j;) {
        if (h = c.charCodeAt(R), R === D && 0 !== x + E + A + C && (0 !== x && (h = 47 === x ? 10 : 47), E = A = C = 0, j++, D++), 0 === x + E + A + C) {
          if (R === D && (0 < W && (F = F.replace(u, "")), 0 < F.trim().length)) {
            switch (h) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                F += c.charAt(R);
            }

            h = 59;
          }

          switch (h) {
            case 123:
              for (f = (F = F.trim()).charCodeAt(0), m = 1, X = ++R; R < j;) {
                switch (h = c.charCodeAt(R)) {
                  case 123:
                    m++;
                    break;

                  case 125:
                    m--;
                    break;

                  case 47:
                    switch (h = c.charCodeAt(R + 1)) {
                      case 42:
                      case 47:
                        e: {
                          for (P = R + 1; P < D; ++P) {
                            switch (c.charCodeAt(P)) {
                              case 47:
                                if (42 === h && 42 === c.charCodeAt(P - 1) && R + 2 !== P) {
                                  R = P + 1;
                                  break e;
                                }

                                break;

                              case 10:
                                if (47 === h) {
                                  R = P + 1;
                                  break e;
                                }

                            }
                          }

                          R = P;
                        }

                    }

                    break;

                  case 91:
                    h++;

                  case 40:
                    h++;

                  case 34:
                  case 39:
                    for (; R++ < D && c.charCodeAt(R) !== h;) {
                      ;
                    }

                }

                if (0 === m) break;
                R++;
              }

              switch (m = c.substring(X, R), 0 === f && (f = (F = F.replace(l, "").trim()).charCodeAt(0)), f) {
                case 64:
                  switch (0 < W && (F = F.replace(u, "")), h = F.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      W = s;
                      break;

                    default:
                      W = S;
                  }

                  if (X = (m = e(s, W, m, h, p + 1)).length, 0 < G && (k = i(3, m, W = r(S, F, T), s, _, O, X, h, p, d), F = W.join(""), void 0 !== k && 0 === (X = (m = k.trim()).length) && (h = 0, m = "")), 0 < X) switch (h) {
                    case 115:
                      F = F.replace(w, o);

                    case 100:
                    case 109:
                    case 45:
                      m = F + "{" + m + "}";
                      break;

                    case 107:
                      m = (F = F.replace(b, "$1 $2")) + "{" + m + "}", m = 1 === I || 2 === I && a("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                      break;

                    default:
                      m = F + m, 112 === d && (J += m, m = "");
                  } else m = "";
                  break;

                default:
                  m = e(s, r(s, F, T), m, d, p + 1);
              }

              L += m, m = T = W = P = f = 0, F = "", h = c.charCodeAt(++R);
              break;

            case 125:
            case 59:
              if (1 < (X = (F = (0 < W ? F.replace(u, "") : F).trim()).length)) switch (0 === P && (f = F.charCodeAt(0), 45 === f || 96 < f && 123 > f) && (X = (F = F.replace(" ", ":")).length), 0 < G && void 0 !== (k = i(1, F, s, t, _, O, J.length, d, p, d)) && 0 === (X = (F = k.trim()).length) && (F = "\0\0"), f = F.charCodeAt(0), h = F.charCodeAt(1), f) {
                case 0:
                  break;

                case 64:
                  if (105 === h || 99 === h) {
                    z += F + c.charAt(R);
                    break;
                  }

                default:
                  58 !== F.charCodeAt(X - 1) && (J += n(F, f, h, F.charCodeAt(2)));
              }
              T = W = P = f = 0, F = "", h = c.charCodeAt(++R);
          }
        }

        switch (h) {
          case 13:
          case 10:
            47 === x ? x = 0 : 0 === 1 + f && 107 !== d && 0 < F.length && (W = 1, F += "\0"), 0 < G * Z && i(0, F, s, t, _, O, J.length, d, p, d), O = 1, _++;
            break;

          case 59:
          case 125:
            if (0 === x + E + A + C) {
              O++;
              break;
            }

          default:
            switch (O++, y = c.charAt(R), h) {
              case 9:
              case 32:
                if (0 === E + C + x) switch (B) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = "";
                    break;

                  default:
                    32 !== h && (y = " ");
                }
                break;

              case 0:
                y = "\\0";
                break;

              case 12:
                y = "\\f";
                break;

              case 11:
                y = "\\v";
                break;

              case 38:
                0 === E + x + C && (W = T = 1, y = "\f" + y);
                break;

              case 108:
                if (0 === E + x + C + N && 0 < P) switch (R - P) {
                  case 2:
                    112 === B && 58 === c.charCodeAt(R - 3) && (N = B);

                  case 8:
                    111 === V && (N = V);
                }
                break;

              case 58:
                0 === E + x + C && (P = R);
                break;

              case 44:
                0 === x + A + E + C && (W = 1, y += "\r");
                break;

              case 34:
              case 39:
                0 === x && (E = E === h ? 0 : 0 === E ? h : E);
                break;

              case 91:
                0 === E + x + A && C++;
                break;

              case 93:
                0 === E + x + A && C--;
                break;

              case 41:
                0 === E + x + C && A--;
                break;

              case 40:
                if (0 === E + x + C) {
                  if (0 === f) switch (2 * B + 3 * V) {
                    case 533:
                      break;

                    default:
                      f = 1;
                  }
                  A++;
                }

                break;

              case 64:
                0 === x + A + E + C + P + m && (m = 1);
                break;

              case 42:
              case 47:
                if (!(0 < E + C + A)) switch (x) {
                  case 0:
                    switch (2 * h + 3 * c.charCodeAt(R + 1)) {
                      case 235:
                        x = 47;
                        break;

                      case 220:
                        X = R, x = 42;
                    }

                    break;

                  case 42:
                    47 === h && 42 === B && X + 2 !== R && (33 === c.charCodeAt(X + 2) && (J += c.substring(X, R + 1)), y = "", x = 0);
                }
            }

            0 === x && (F += y);
        }

        V = B, B = h, R++;
      }

      if (0 < (X = J.length)) {
        if (W = s, 0 < G && void 0 !== (k = i(2, J, W, t, _, O, X, d, p, d)) && 0 === (J = k).length) return z + J + L;

        if (J = W.join(",") + "{" + J + "}", 0 != I * N) {
          switch (2 !== I || a(J, 2) || (N = 0), N) {
            case 111:
              J = J.replace(v, ":-moz-$1") + J;
              break;

            case 112:
              J = J.replace(g, "::-webkit-input-$1") + J.replace(g, "::-moz-$1") + J.replace(g, ":-ms-input-$1") + J;
          }

          N = 0;
        }
      }

      return z + J + L;
    }(S, s, t, 0, 0);

    return 0 < G && void 0 !== (c = i(-2, d, s, s, _, O, d.length, 0, 0, 0)) && (d = c), N = 0, O = _ = 1, d;
  }

  var l = /^\0+/g,
      u = /[\0\r\f]/g,
      d = /: */g,
      p = /zoo|gra/,
      f = /([,: ])(transform)/g,
      h = /,\r+?/g,
      m = /([\t\r\n ])*\f?&/g,
      b = /@(k\w+)\s*(\S*)\s*/,
      g = /::(place)/g,
      v = /:(read-only)/g,
      y = /[svh]\w+-[tblr]{2}/,
      w = /\(\s*(.*)\s*\)/g,
      k = /([\s\S]*?);/g,
      C = /-self|flex-/g,
      x = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      A = /stretch|:\s*\w+\-(?:conte|avail)/,
      E = /([^-])(image-set\()/,
      O = 1,
      _ = 1,
      N = 0,
      I = 1,
      S = [],
      B = [],
      G = 0,
      V = null,
      Z = 0;
  return c.use = function e(r) {
    switch (r) {
      case void 0:
      case null:
        G = B.length = 0;
        break;

      default:
        if ("function" == typeof r) B[G++] = r;else if ("object" == typeof r) for (var t = 0, n = r.length; t < n; ++t) {
          e(r[t]);
        } else Z = 0 | !!r;
    }

    return e;
  }, c.set = s, void 0 !== e && s(e), c;
}

function h(e) {
  e && m.current.insert(e + "}");
}

var m = {
  current: null
},
    b = function b(e, r, t, n, a, o, i, s, c, l) {
  switch (e) {
    case 1:
      switch (r.charCodeAt(0)) {
        case 64:
          return m.current.insert(r + ";"), "";

        case 108:
          if (98 === r.charCodeAt(2)) return "";
      }

      break;

    case 2:
      if (0 === s) return r + "/*|*/";
      break;

    case 3:
      switch (s) {
        case 102:
        case 112:
          return m.current.insert(t[0] + r), "";

        default:
          return r + (0 === l ? "/*|*/" : "");
      }

    case -2:
      r.split("/*|*/}").forEach(h);
  }
};

function g(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function (t) {
    void 0 !== e[t] ? r.push(e[t]) : n += t + " ";
  }), n;
}

var v = function v(e, r, t) {
  var n = e.key + "-" + r.name;

  if (!1 === t && void 0 === e.registered[n] && (e.registered[n] = r.styles), void 0 === e.inserted[r.name]) {
    var a = r;

    do {
      e.insert("." + n, a, e.sheet, !0), a = a.next;
    } while (void 0 !== a);
  }
},
    y = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    w = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    k = /[A-Z]|^ms/g,
    C = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    x = function x(e) {
  return 45 === e.charCodeAt(1);
},
    A = l(function (e) {
  return x(e) ? e : e.replace(k, "-$&").toLowerCase();
}),
    E = function E(e, r) {
  if (null == r || "boolean" == typeof r) return "";

  switch (e) {
    case "animation":
    case "animationName":
      if ("string" == typeof r) return r.replace(C, function (e, r, t) {
        return P = {
          name: r,
          styles: t,
          next: P
        }, r;
      });
  }

  return 1 === y[e] || x(e) || "number" != typeof r || 0 === r ? r : r + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var O = /(attr|calc|counters?|url)\(/,
      _ = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      N = E,
      I = /^-ms-/,
      S = /-(.)/g,
      B = {};

  E = function E(e, r) {
    "content" === e && ("string" != typeof r || -1 === _.indexOf(r) && !O.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || '"' !== r.charAt(0) && "'" !== r.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + r + "\"'`");
    var t = N(e, r);
    return "" === t || x(e) || -1 === e.indexOf("-") || void 0 !== B[e] || (B[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(I, "ms-").replace(S, function (e, r) {
      return r.toUpperCase();
    }) + "?")), t;
  };
}

var G = !0;

function V(e, r, t, n) {
  if (null == t) return "";

  if (void 0 !== t.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === t.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return t;
  }

  switch (typeof t) {
    case "boolean":
      return "";

    case "object":
      if (1 === t.anim) return P = {
        name: t.name,
        styles: t.styles,
        next: P
      }, t.name;

      if (void 0 !== t.styles) {
        var a = t.next;
        if (void 0 !== a) for (; void 0 !== a;) {
          P = {
            name: a.name,
            styles: a.styles,
            next: P
          }, a = a.next;
        }
        var o = t.styles;
        return "production" !== process.env.NODE_ENV && void 0 !== t.map && (o += t.map), o;
      }

      return function (e, r, t) {
        var n = "";
        if (Array.isArray(t)) for (var a = 0; a < t.length; a++) {
          n += V(e, r, t[a], !1);
        } else for (var o in t) {
          var i = t[o];
          if ("object" != typeof i) n += null != r && void 0 !== r[i] ? o + "{" + r[i] + "}" : A(o) + ":" + E(o, i) + ";";else {
            if ("NO_COMPONENT_SELECTOR" === o && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");

            if (!Array.isArray(i) || "string" != typeof i[0] || null != r && void 0 !== r[i[0]]) {
              var s = V(e, r, i, !1);

              switch (o) {
                case "animation":
                case "animationName":
                  n += A(o) + ":" + s + ";";
                  break;

                default:
                  n += o + "{" + s + "}";
              }
            } else for (var c = 0; c < i.length; c++) {
              n += A(o) + ":" + E(o, i[c]) + ";";
            }
          }
        }
        return n;
      }(e, r, t);

    case "function":
      if (void 0 !== e) {
        var i = P,
            s = t(e);
        return P = i, V(e, r, s, n);
      }

      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");

    default:
      if (null == r) return t;
      var c = r[t];
      return "production" !== process.env.NODE_ENV && n && G && void 0 !== c && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), G = !1), void 0 === c || n ? t : c;
  }
}

var Z,
    P,
    R = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (Z = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);

var W = function W(e, r, t) {
  if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
  var n = !0,
      a = "";
  P = void 0;
  var o,
      i = e[0];
  null == i || void 0 === i.raw ? (n = !1, a += V(t, r, i, !1)) : ("production" !== process.env.NODE_ENV && void 0 === i[0] && console.error(w), a += i[0]);

  for (var s = 1; s < e.length; s++) {
    a += V(t, r, e[s], 46 === a.charCodeAt(a.length - 1)), n && ("production" !== process.env.NODE_ENV && void 0 === i[s] && console.error(w), a += i[s]);
  }

  "production" !== process.env.NODE_ENV && (a = a.replace(Z, function (e) {
    return o = e, "";
  })), R.lastIndex = 0;

  for (var c, l = ""; null !== (c = R.exec(a));) {
    l += "-" + c[1];
  }

  var u = function (e) {
    for (var r, t = e.length, n = t ^ t, a = 0; t >= 4;) {
      r = 1540483477 * (65535 & (r = 255 & e.charCodeAt(a) | (255 & e.charCodeAt(++a)) << 8 | (255 & e.charCodeAt(++a)) << 16 | (255 & e.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), n = 1540483477 * (65535 & n) + ((1540483477 * (n >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), t -= 4, ++a;
    }

    switch (t) {
      case 3:
        n ^= (255 & e.charCodeAt(a + 2)) << 16;

      case 2:
        n ^= (255 & e.charCodeAt(a + 1)) << 8;

      case 1:
        n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(a))) + ((1540483477 * (n >>> 16) & 65535) << 16);
    }

    return n = 1540483477 * (65535 & (n ^= n >>> 13)) + ((1540483477 * (n >>> 16) & 65535) << 16), ((n ^= n >>> 15) >>> 0).toString(36);
  }(a) + l;

  return "production" !== process.env.NODE_ENV ? {
    name: u,
    styles: a,
    map: o,
    next: P
  } : {
    name: u,
    styles: a,
    next: P
  };
},
    T = e("undefined" != typeof HTMLElement ? function (e) {
  void 0 === e && (e = {});
  var r,
      t = e.key || "css";
  void 0 !== e.prefix && (r = {
    prefix: e.prefix
  });
  var n = new f(r);
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var a,
      o = {};
  a = e.container || document.head;
  var i,
      s = document.querySelectorAll("style[data-emotion-" + t + "]");

  if (Array.prototype.forEach.call(s, function (e) {
    e.getAttribute("data-emotion-" + t).split(" ").forEach(function (e) {
      o[e] = !0;
    }), e.parentNode !== a && a.appendChild(e);
  }), n.use(e.stylisPlugins)(b), i = function i(e, r, t, a) {
    var o = r.name;

    if (m.current = t, "production" !== process.env.NODE_ENV && void 0 !== r.map) {
      var i = r.map;
      m.current = {
        insert: function insert(e) {
          t.insert(e + i);
        }
      };
    }

    n(e, r.styles), a && (u.inserted[o] = !0);
  }, "production" !== process.env.NODE_ENV) {
    var c = /\/\*/g,
        l = /\*\//g;
    n.use(function (e, r) {
      switch (e) {
        case -1:
          for (; c.test(r);) {
            if (l.lastIndex = c.lastIndex, !l.test(r)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            c.lastIndex = l.lastIndex;
          }

          c.lastIndex = 0;
      }
    }), n.use(function (e, r, t) {
      switch (e) {
        case -1:
          var n = r.match(/(:first|:nth|:nth-last)-child/g);
          n && !0 !== u.compat && n.forEach(function (e) {
            var t = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(r);
            e && !t && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
          });
      }
    });
  }

  var u = {
    key: t,
    sheet: new p({
      key: t,
      container: a,
      nonce: e.nonce,
      speedy: e.speedy
    }),
    nonce: e.nonce,
    inserted: o,
    registered: {},
    insert: i
  };
  return u;
}() : null),
    X = e({}),
    j = function j(e) {
  return r(function (r, n) {
    return t(T.Consumer, null, function (t) {
      return e(r, t, n);
    });
  });
},
    D = Object.prototype.hasOwnProperty,
    F = function F(e, r, n, a) {
  var o = r.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      i = [],
      s = "",
      c = null === n ? r.css : r.css(n);
  "string" == typeof c && void 0 !== e.registered[c] && (c = e.registered[c]), i.push(c), void 0 !== r.className && (s = g(e.registered, i, r.className));
  var l = W(i);

  if ("production" !== process.env.NODE_ENV && -1 === l.name.indexOf("-")) {
    var u = r.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    u && (l = W([l, "label:" + u + ";"]));
  }

  v(e, l, "string" == typeof o), s += e.key + "-" + l.name;
  var d = {};

  for (var p in r) {
    !D.call(r, p) || "css" === p || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === p || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === p || (d[p] = r[p]);
  }

  return d.ref = a, d.className = s, t(o, d);
},
    J = j(function (e, r, n) {
  return "function" == typeof e.css ? t(X.Consumer, null, function (t) {
    return F(r, e, t, n);
  }) : F(r, e, null, n);
});

"production" !== process.env.NODE_ENV && (J.displayName = "EmotionCssPropInternal");

var L = function e(r) {
  for (var t = r.length, n = 0, a = ""; n < t; n++) {
    var o = r[n];

    if (null != o) {
      var i = void 0;

      switch (typeof o) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(o)) i = e(o);else for (var s in i = "", o) {
            o[s] && s && (i && (i += " "), i += s);
          }
          break;

        default:
          i = o;
      }

      i && (a && (a += " "), a += i);
    }
  }

  return a;
};

function z(e, r, t) {
  var n = [],
      a = g(e, n, t);
  return n.length < 2 ? t : a + r(n);
}

j(function (e, r) {
  return t(X.Consumer, null, function (t) {
    var n = !1,
        a = function a() {
      if (n && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");

      for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
        t[a] = arguments[a];
      }

      var o = W(t, r.registered);
      return v(r, o, !1), r.key + "-" + o.name;
    },
        o = e.children({
      css: a,
      cx: function cx() {
        if (n && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");

        for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) {
          t[o] = arguments[o];
        }

        return z(r.registered, a, L(t));
      },
      theme: t
    });

    return n = !0, o;
  });
});

var H = d,
    Y = function Y(e) {
  return "theme" !== e && "innerRef" !== e;
},
    U = function U(e) {
  return "string" == typeof e && e.charCodeAt(0) > 96 ? H : Y;
};

function M(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }

  return t;
}

function Q(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? M(t, !0).forEach(function (r) {
      c(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : M(t).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var q = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    $ = function e(r, n) {
  if ("production" !== process.env.NODE_ENV && void 0 === r) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var a, o, i;
  void 0 !== n && (a = n.label, i = n.target, o = r.__emotion_forwardProp && n.shouldForwardProp ? function (e) {
    return r.__emotion_forwardProp(e) && n.shouldForwardProp(e);
  } : n.shouldForwardProp);
  var s = r.__emotion_real === r,
      c = s && r.__emotion_base || r;
  "function" != typeof o && s && (o = r.__emotion_forwardProp);
  var l = o || U(c),
      u = !l("as");
  return function () {
    var d = arguments,
        p = s && void 0 !== r.__emotion_styles ? r.__emotion_styles.slice(0) : [];
    if (void 0 !== a && p.push("label:" + a + ";"), null == d[0] || void 0 === d[0].raw) p.push.apply(p, d);else {
      "production" !== process.env.NODE_ENV && void 0 === d[0][0] && console.error(q), p.push(d[0][0]);

      for (var f = d.length, h = 1; h < f; h++) {
        "production" !== process.env.NODE_ENV && void 0 === d[0][h] && console.error(q), p.push(d[h], d[0][h]);
      }
    }
    var m = j(function (e, r, n) {
      return t(X.Consumer, null, function (s) {
        var d = u && e.as || c,
            f = "",
            h = [],
            m = e;

        if (null == e.theme) {
          for (var b in m = {}, e) {
            m[b] = e[b];
          }

          m.theme = s;
        }

        "string" == typeof e.className && (f += g(r.registered, h, e.className));
        var y = W(p.concat(h), r.registered, m);
        v(r, y, "string" == typeof d), f += r.key + "-" + y.name, void 0 !== i && (f += " " + i);
        var w = u && void 0 === o ? U(d) : l,
            k = {};

        for (var C in e) {
          u && "as" === C || w(C) && (k[C] = e[C]);
        }

        return k.className = f, k.ref = n || e.innerRef, "production" !== process.env.NODE_ENV && e.innerRef && console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (void 0 === a ? "" : " in the usage of `" + a + "`")), t(d, k);
      });
    });
    return m.displayName = void 0 !== a ? a : "Styled(" + ("string" == typeof c ? c : c.displayName || c.name || "Component") + ")", m.defaultProps = r.defaultProps, m.__emotion_real = m, m.__emotion_base = c, m.__emotion_styles = p, m.__emotion_forwardProp = o, Object.defineProperty(m, "toString", {
      value: function value() {
        return void 0 === i && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + i;
      }
    }), m.withComponent = function (r, t) {
      return e(r, void 0 !== t ? Q({}, n || {}, {}, t) : n).apply(void 0, p);
    }, m;
  };
},
    K = function K(e) {
  var r = e.renderTooltip,
      a = s(e, ["renderTooltip"]);
  return t(n, i({
    renderPopover: r,
    mouseMoveBehavior: !0
  }, a));
};

K.defaultProps = {
  closeOnMouseOutside: !0
};
var ee = $(r(function (e, r) {
  var n = e.arrowProps,
      c = e.children,
      l = s(e, ["arrowProps", "children"]);
  return t(a, i({}, l, {
    arrowProps: n,
    ref: r
  }), c, t(o, {
    ref: n.ref
  }));
}), {
  target: "eiluiu10",
  label: "Container"
})("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export { ee as Container, K as Tooltip };